// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PwbfeOWv {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
}

.jWZH9DYt {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  padding: 2.5rem;
  width: 100%;
  max-width: 400px;
}

.fgFOOlIN {
  font-size: 1.5rem;
  color: #4ecca3;
  margin-bottom: 1.5rem;
  text-align: center;
}

.mTAToRJ9 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.uxpUIoC3 {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  color: #b0b0c0;
  font-size: 0.9rem;
}

.DJvtQkGf {
  padding: 0.6rem 0.8rem;
  background: #1a1a2e;
  border: 1px solid #2a2a4a;
  border-radius: 6px;
  color: #e0e0e0;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.DJvtQkGf:focus {
  border-color: #4ecca3;
}

.Kfb2LxEl {
  color: #ff6b6b;
  font-size: 0.85rem;
  padding: 0.5rem;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 4px;
}

.x4gkAtHA {
  padding: 0.7rem;
  background: #4ecca3;
  color: #1a1a2e;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.5rem;
}

.x4gkAtHA:hover {
  background: #3db893;
}

.x4gkAtHA:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sNsafSK8 {
  text-align: center;
  margin-top: 1rem;
  color: #808090;
  font-size: 0.85rem;
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .PwbfeOWv {
    padding: 1rem;
  }

  .jWZH9DYt {
    padding: 1.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Auth.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  padding: 2rem;\n}\n\n.card {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 400px;\n}\n\n.title {\n  font-size: 1.5rem;\n  color: #4ecca3;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  color: #b0b0c0;\n  font-size: 0.9rem;\n}\n\n.input {\n  padding: 0.6rem 0.8rem;\n  background: #1a1a2e;\n  border: 1px solid #2a2a4a;\n  border-radius: 6px;\n  color: #e0e0e0;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.input:focus {\n  border-color: #4ecca3;\n}\n\n.error {\n  color: #ff6b6b;\n  font-size: 0.85rem;\n  padding: 0.5rem;\n  background: rgba(255, 107, 107, 0.1);\n  border-radius: 4px;\n}\n\n.button {\n  padding: 0.7rem;\n  background: #4ecca3;\n  color: #1a1a2e;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.5rem;\n}\n\n.button:hover {\n  background: #3db893;\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.link {\n  text-align: center;\n  margin-top: 1rem;\n  color: #808090;\n  font-size: 0.85rem;\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .card {\n    padding: 1.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PwbfeOWv`,
	"card": `jWZH9DYt`,
	"title": `fgFOOlIN`,
	"form": `mTAToRJ9`,
	"label": `uxpUIoC3`,
	"input": `DJvtQkGf`,
	"error": `Kfb2LxEl`,
	"button": `x4gkAtHA`,
	"link": `sNsafSK8`
};
export default ___CSS_LOADER_EXPORT___;
